import * as Popover from '@radix-ui/react-popover';

import { styled } from '@lichtblick/styled';
import { Colors, Spacing } from '@lichtblick/theme';

export const Wrapper = styled.div<{ $maxWidth?: string }>`
  background-color: ${Colors.white};
  border: ${`1px solid ${Colors.blue['20']}`};
  border-radius: ${Spacing['3Xs']};
  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.1);
  ${({ $maxWidth }) => $maxWidth && `max-width: ${$maxWidth};`}
  padding: ${Spacing.Xs};
  word-wrap: break-word;
`;

export const PopoverContent = styled(Popover.Content)`
  z-index: 1000;
`;
